export default "__VITE_ASSET__Cl6Fcls8__"